import { Component, Input, OnInit } from '@angular/core';

// services
import { ConfigService } from '@campfire-nx/api';

@Component({
  selector: 'app-claims-list',
  templateUrl: './claims-list.component.html',
  styleUrls: ['./claims-list.component.scss']
})
export class ClaimsListComponent {
  @Input() claims!: any;
  @Input() label!: string;
  configData!: any;

  constructor(
    private configService: ConfigService
  ) { }

  ngOnInit() {
    this.configData = this.configService.data;
  }

  getClaimType(productType: string, eventType: string) {
    let claimTypeLabel = '-';
    const claimTypes = this.configData.types.claimTypes[productType];
    const claimEventTypes = this.configData.types.claimEventTypes;

    Object.entries<any>(claimTypes).forEach(([claimKey]) => {
      Object.entries<any>(claimEventTypes[claimKey]).forEach(([eventKey, eventValue]) => {
        let continues = true;

        if (eventType === eventKey) {
          claimTypeLabel = eventValue.label

          continues = false
        }
        return continues;
      })

      return claimTypeLabel === '-';
    });

    return claimTypeLabel
  }

  getClaimStatus(claimState: string) {
    switch (claimState) {
      case 'F': // Finalised
        return 'success';
      case 'H': // On hold
        return 'error';
      case 'D' || 'L' || 'Q' || 'W' || 'X': // Draft, Member waiting / In progress, Finance Outstanding, Withdrawn, Void
      default:
        return 'default';
    }
  }

  getIcon(productType: string){
    switch (productType) {
      case 'C':
        return 'management-damagecar-small';
      case 'H':
        return 'management-damagehouse-small';
      case 'T':
        return 'travel-small';
      default:
        return '';
    }
  }
}

